export default __webpack_public_path__ + "media/images/images_v2/bordright-onglet-32c18f6f5e91c349c7507c3cc1c8f66a.png";